import { render, staticRenderFns } from "./nextCollect.vue?vue&type=template&id=7d5b3482&scoped=true"
import script from "./nextCollect.vue?vue&type=script&lang=js"
export * from "./nextCollect.vue?vue&type=script&lang=js"
import style0 from "./nextCollect.vue?vue&type=style&index=0&id=7d5b3482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5b3482",
  null
  
)

export default component.exports